import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dispatchertakes" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-2" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_5 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_take_order_list_item = _resolveComponent("take-order-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.loadTakesList(1)), ["prevent"])),
      class: "bg-white border px-6 py-4"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_select, {
          value: _ctx.filters_state.dispatchers_sector_id,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.dispatchers_sector_id) = $event)),
          placeholder: "Выберите сектор диспетчера",
          loading: _ctx.data_state.dispatchers_sectors.is_loading,
          options: _ctx.data_state.dispatchers_sectors.list,
          failed: _ctx.data_state.dispatchers_sectors.is_failed,
          "error-text": "При получении списка секторов диспетчера произошла ошибка",
          "search-by": "name",
          "select-by": "id",
          label: "name",
          onRefresh: _ctx.loadDispatchersSectors
        }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
        _createVNode(_component_the_select, {
          value: _ctx.filters_state.courier_id,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.courier_id) = $event)),
          placeholder: "Выберите курьера",
          label: "fullName",
          "search-by": "fullName",
          options: _ctx.data_state.couriers.list,
          loading: _ctx.data_state.couriers.is_loading,
          failed: _ctx.data_state.couriers.is_failed,
          "error-text": "При получении списка курьеров произошла ошибка",
          "infinite-scroll": "",
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCouriers(_ctx.data_state.couriers.pagination.current_page))),
          onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCouriers(_ctx.data_state.couriers.pagination.current_page + 1))),
          onSearch: _ctx.searchCourier,
          onOptionBySearch: _ctx.unshiftFindedCourier
        }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_input, {
          placeholder: "ID заказа",
          value: _ctx.filters_state.order_id,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.order_id) = $event)),
          disabled: _ctx.state.is_loading
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Код 1С заказа",
          value: _ctx.filters_state.order_number_1c,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.order_number_1c) = $event)),
          disabled: _ctx.state.is_loading
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_the_select, {
          value: _ctx.filters_state.status_ids,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.status_ids) = $event)),
          class: "mt-2",
          placeholder: "Статус",
          loading: _ctx.data_state.statuses.is_loading,
          failed: _ctx.data_state.statuses.is_failed,
          options: _ctx.data_state.statuses.list,
          multiselect: "",
          onRefresh: _ctx.loadStatuses
        }, null, 8, ["value", "loading", "failed", "options", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Компания",
          loading: _ctx.data_state.companies.is_loading,
          failed: _ctx.data_state.companies.is_failed,
          options: _ctx.data_state.companies.list,
          value: _ctx.filters_state.company_ids,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.company_ids) = $event)),
          multiselect: "",
          "infinite-scroll": "",
          onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
          onLoadmore: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
          onSearch: _ctx.searchCompanies,
          onOptionBySearch: _ctx.unshiftFindedCompany
        }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second small text mr-3",
          loading: _ctx.state.is_loading,
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createVNode(_component_page_title, {
      class: "mt-6",
      title: "Список заборов"
    }),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка заборов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadTakesList(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.state.is_loading,
            items: _ctx.state.list,
            pagination: "",
            "pagination-current-page": _ctx.state.pagination.current_page,
            "pagination-total-pages": _ctx.state.pagination.total_pages,
            onChangePage: _ctx.loadTakesList
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_take_order_list_item, {
                item: item,
                onItemRemoved: _ctx.onOrderRemoved
              }, null, 8, ["item", "onItemRemoved"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}